/**
 *  Carousel script file
**/

export default {
  name: 'Carousel',
  mixins: [],
  components: {},
  props: {
    label: {
      type: String,
      default: 'items',
      required: false
    },
    step: {
      type: Number,
      default: 1,
      required: false
    },
    margin: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data () {
    return {
      items: [],
      activeItems: [],
      currentItem: 0,
      currentOffset: 0
    }
  },
  computed: {
    totalItems () {
      return this.items.length
    },
    itemWidth () {
      return this.items[0]
        ? this.items[0].offsetWidth + this.margin
        : 0
    },
    carouselWidth () {
      return this.$refs.carousel
        ? this.$refs.carousel.getBoundingClientRect().width
        : 0
    },
    visibleItems () {
      return Math.floor(this.carouselWidth / (this.itemWidth || 1))
    },
    transform () {
      return { transform: `translate3d(${this.currentOffset}px, 0, 0)` }
    },
    paginationLabel () {
      return `${this.currentItem + 1}-${this.currentItem + this.step}`
    }
  },
  mounted () {
    this.observer = new MutationObserver(() => this.setItems())
    this.observer.observe(this.$refs.carousel, { childList: true, subtree: true })
  },
  beforeDestroy () {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setItems () {
      this.$nextTick(() => {
        this.items = Array.from(this.$refs.carousel.childNodes)
        this.items.forEach(item => {
          item.classList.add('carousel-item')
          item.addEventListener('click', this.onItemClick, false)
        })
        this.setActiveItems()
      })
    },
    next () {
      if (this.currentItem < this.totalItems - this.step) {
        this.currentItem++
        this.currentOffset -= this.itemWidth
        this.setActiveItems()
      }
    },
    prev () {
      if (this.currentItem > 0) {
        this.currentItem--
        this.currentOffset += this.itemWidth
        this.setActiveItems()
      }
    },
    setActiveItems () {
      this.items.forEach((item, index) => {
        if (this.isActive(index)) {
          item.classList.add('active')
        } else {
          item.classList.remove('active')
        }
      })
    },
    isActive (index) {
      const start = this.currentItem
      const end = this.currentItem + this.step
      return index >= start && index < end
    },
    onItemClick (event) {
      const index = this.items.indexOf(event.currentTarget)
      if (index === -1 || this.isActive(index)) {
        return
      }
      if (index >= this.currentItem) {
        this.next()
      } else {
        this.prev()
      }
    }
  }
}
